import type { Message } from '@vexalyn/shared';

export class MessageHistory {
  private readonly messages: Message[] = [];

  add(message: Message): void {
    this.messages.push({ ...message });
  }

  list(): readonly Message[] {
    return this.messages.map((message) => ({ ...message }));
  }

  clear(): void {
    this.messages.length = 0;
  }
}

export { detectProjectType, detectProjectInfo } from './project-detector.js';
export { resolveSafePath } from './security.js';
export { generateRepositoryMap, formatCompactRepositoryMap } from './repository-map.js';
export { loadIgnoreRules, createIgnoreMatcher } from './ignore-rules.js';
export { scanProjectStructure } from './structure-scanner.js';
export { readImportantFiles, isSecretPath, isImportantPath } from './important-files.js';
export { readGitStatus } from './git-reader.js';
export { buildProjectContext, formatProjectContext } from './context-builder.js';
export { getCachedProjectContext, setCachedProjectContext, invalidateProjectContext } from './cache.js';
export type { ProjectInfo, ProjectStructure, GitStatus, ContextBudget, ProjectContext } from './context-types.js';
